// src/components/Header.js
import React from 'react';
import RequestComponent from '../Other/RequestComponent';
import OurTestimonials from '../Other/OurTestimonials';
function Home() {
  return (
    <div>
      <div className="hero1" style={{
        backgroundImage: "url('assets/img/bg/hero1-bg.png')",
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
      }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-5">
              <div className="main-headding">
                <span className="span" data-aos="zoom-in-left" data-aos-duration="700"> M2V Consulting & IT Solution</span>
                <h1 className="title tg-element-title">Aligning Technology, <span className="after">  with Your Business Goals</span></h1>
                <div className="space16"></div>
                <p>With a global delivery footprint, M2V Consulting partners with organizations across diverse industries — including financial services, healthcare, public sector, energy, retail, and telecommunications. Our adaptable engagement models and domain-agnostic expertise enable us to address complex business challenges at any scale, delivering tailored solutions that drive success across sectors.</p>

                <div className="space30"></div>
                <div className="buttons">
                  <a className="theme-btn1" href="/services">Get Started Now <span><i className="fa-solid fa-arrow-right"></i></span></a>
                  {/* <a className="play-btn" href="https://www.youtube.com/watch?v=kcfs1-ryKWE"><span><i className="fa-regular fa-play"></i></span> Watch Demo Video</a> */}
                </div>
              </div>
            </div>

            <div className="col-lg-7">
              <div className="hero1-all-images">
                <div className="image1 ">
                  <img src="assets/img/brainstorming-concept-online-assistant-at-work-manager-at-remote-work-searching-for-new-ideas-solutions-working-together-in-the-company-flat-modern-illustration-vector-removebg-preview.png" alt="" />
                </div>
                <div className="image2 reveal">
                  <img src="assets/img/brainstorming-concept-online-assistant-at-work-manager-at-remote-work-searching-for-new-ideas-solutions-working-together-in-the-company-flat-modern-illustration-vector-removebg-preview.png" alt="" />
                </div>
                <div className="image3 shape-animaiton3">
                  {/* <img src="assets/img/hero/hero1-image3.png" alt="" /> */}
                </div>
                <div className="image4 shape-animaiton3">
                  {/* <img src="assets/img/hero/hero1-image4.png" alt="" /> */}
                </div>
                <div className="shape1">
                  {/* <img src="assets/img/shapes/header1-shape1.png" alt="" /> */}
                </div>
                <div className="shape2">
                  {/* <img src="assets/img/shapes/header1-shape2.png" alt="" /> */}
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      

      {/* <div class="about2 about-page-sec sp">
                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-lg-6">
                            <div class="about2-images">
                                <div class="image1">
                                    <img src="assets/img/about/about2-img1.png" alt="" />
                                </div>
                                <div class="image2">
                                    <img src="assets/img/about/about2-img2.png" alt="" />
                                </div>
                                <div class="image3">
                                    <img src="assets/img/about/about2-img3.png" alt="" />
                                </div>
                                <div class="counter-box">
                                    <h3>15</h3>
                                    <p>Years Of <br /> Experience</p>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-6">
                            <div class="heading1">
                                <span class="span"><img src="assets/img/icons/span1.png" alt="" /> About Us</span>
                                <h2>Empower Your Business With Our Expert Consulting & Technology Solutions</h2>
                                <div class="space16"></div>
                                <p>M2V Consulting is a globally recognized ServiceNow Elite Partner, delivering over 15 years of specialized experience in architecting and implementing scalable, enterprise-grade digital workflow solutions. Our team offers comprehensive advisory, integration, and managed services across the full ServiceNow ecosystem — including ITSM, ITOM, SecOps, HRSD, CSM, and custom app development.</p>

                                <div class="space10"></div>
<p>We enable organizations to streamline complex business processes, enhance cross-functional automation, and unlock operational efficiencies through data-driven service delivery and platform-centric innovation.</p>
                               
                                <div class="space30"></div>
                                <div class="button">
                                    <a class="theme-btn1" href="/contact_us">Contact Us <span><i class="fa-solid fa-arrow-right"></i></span></a>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div> */}

<div class="space30"></div>
          <div class="servcie2 service-page-sec">
          <div className="row">
            <div className="col-lg-8 m-auto text-center">
              <div className="heading1">
                <span className="span" data-aos="zoom-in-left" data-aos-duration="700"><img src="assets/img/icons/span1.png" alt="" /> Our Services</span>
                <h2 className="title tg-element-title">Empower Your Business With Our Comprehensive Technology & IT Solutions</h2>
              </div>
            </div>
          </div>
                <div class="">
                    <div class="row">
                    <div class="col-lg-6 col-md-6">
                            <div class="">
                                <div class="servcie2-box">
                                    <div class="icon">
                                        <img src="assets/img/icons/service-page-icon5.png" alt="" />
                                    </div>
                                    <a href="#" class="arrow"><i class="fa-solid fa-arrow-right"></i></a>
                                    <div class="heading1">
                                        <h4><a href="#">Cross-Platform Expertise</a></h4>
                                        <div class="space16"></div>
                                        <p>Our deep domain knowledge spans the entire ServiceNow ecosystem — including ITSM, ITOM, HRSD, CSM, SecOps, App Engine, GRC, and more — enabling truly integrated enterprise solutions.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                       

                        <div class="col-lg-6 col-md-6">
                            <div class="">
                                <div class="servcie2-box">
                                    <div class="icon">
                                        <img src="assets/img/icons/service-page-icon2.png" alt="" />
                                    </div>
                                    <a href="#" class="arrow"><i class="fa-solid fa-arrow-right"></i></a>
                                    <div class="heading1">
                                        <h4><a href="#">End-to-End Implementation</a></h4>
                                        <div class="space16"></div>
                                        <p>From architecture and design to development and deployment, we manage full lifecycle ServiceNow implementations across all modules, delivering scalable solutions with speed, precision, and adherence to best practices.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6">
                            <div class="">
                                <div class="servcie2-box">
                                    <div class="icon">
                                        <img src="assets/img/icons/service-page-icon3.png" alt="" />
                                    </div>
                                    <a href="#" class="arrow"><i class="fa-solid fa-arrow-right"></i></a>
                                    <div class="heading1">
                                        <h4><a href="#">Training & Enablement</a></h4>
                                        <div class="space16"></div>
                                        <p>Empower your workforce with tailored training programs for administrators, developers, and end-users — designed to build in-house capabilities and ensure long-term platform success.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6">
                            <div class="">
                                <div class="servcie2-box">
                                    <div class="icon">
                                        <img src="assets/img/icons/service-page-icon4.png" alt="" />
                                    </div>
                                    <a href="#" class="arrow"><i class="fa-solid fa-arrow-right"></i></a>
                                    <div class="heading1">
                                        <h4><a href="#">Platform Optimization & Enhancements</a></h4>
                                        <div class="space16"></div>
                                        <p>We continuously optimize your ServiceNow environment by improving performance, streamlining workflows, and implementing new features that evolve with your business needs.</p>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                        <div class="col-lg-4 col-md-6">
                            <div class="">
                                <div class="servcie2-box">
                                    <div class="icon">
                                        <img src="assets/img/icons/service-page-icon1.png" alt="" />
                                    </div>
                                    <a href="#" class="arrow"><i class="fa-solid fa-arrow-right"></i></a>
                                    <div class="heading1">
                                        <h4><a href="#">ServiceNow Strategy & Advisory</a></h4>
                                        <div class="space16"></div>
                                        <p>We provide strategic guidance through platform assessments, roadmap development, and value realization planning — ensuring alignment with your business objectives and maximizing ROI.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        

                        

                    </div>

                </div>
            </div>
        
      
      <div className="work sp">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="heading1">
                <span className="span" data-aos="zoom-in-left" data-aos-duration="700"><img src="assets/img/icons/span1.png" alt="" />Best IT Solution</span>
                <h2 className="title tg-element-title"> Our ServiceNow Expertise</h2>
                <div className="space16"></div>
                <p data-aos="fade-right" data-aos-duration="700">At M2V Consulting, we deliver end-to-end solutions across the entire ServiceNow ecosystem — enabling enterprises to streamline operations, enhance experiences, and accelerate digital transformation.</p>

                <div className="single-items" data-aos="fade-right" data-aos-duration="700">
                  <div className="">
                    <div className="icon">
                      <img src="assets/img/icons/work-iocn1.png" alt="" />
                    </div>
                  </div>
                  <div className="">
                    <h4><a href="#">IT Workflows</a></h4>
                    <div className="space10"></div>
                    <p>Streamline IT operations with ITSM, ITOM, ITAM, CMDB, and Cloud Management.</p>
                  </div>
                </div>

                <div className="single-items" data-aos="fade-right" data-aos-duration="900">
                  <div className="">
                    <div className="icon">
                      <img src="assets/img/icons/work-iocn2.png" alt="" />
                    </div>
                  </div>
                  <div className="">
                    <h4><a href="#">Employee Workflows</a></h4>
                    <div className="space10"></div>
                    <p>Improve employee experience with HR and Workplace Service Delivery.

</p>
                  </div>
                </div>

                <div className="single-items" data-aos="fade-right" data-aos-duration="1100">
                  <div className="">
                    <div className="icon">
                      <img src="assets/img/icons/work-iocn3.png" alt="" />
                    </div>
                  </div>
                  <div className="">
                    <h4><a href="#">Customer Workflows</a></h4>
                    <div className="space10"></div>
                    <p>Enhance customer support through CSM and Field Service Management.</p>
                  </div>
                </div>


              </div>
              <div className="space30"></div>
              <div className="" data-aos="fade-right" data-aos-duration="800">
                <a className="theme-btn1" href="/services">What we Offer <span><i className="fa-solid fa-arrow-right"></i></span></a>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="work-images">
                <div className="row align-items-center">
                  <div className="col-md-6">
                    <div className="image reveal image-anime">
                      <img src="assets/img/work/work-img1.png" alt="" />
                    </div>
                    <div className="image reveal image-anime">
                      <img src="assets/img/work/work-img3.png" alt="" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="image reveal image-anime">
                      <img src="assets/img/work/work-img2.png" alt="" />
                    </div>
                  </div>
                </div>
                <img src="assets/img/bg12.jpeg" alt="" className="bg-image " />
              </div>
            </div>
          </div>
        </div>
      </div>
{/* <div className="project sp">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 m-auto text-center">
              <div className="heading1">
                <span className="span" data-aos="zoom-in-left" data-aos-duration="700"><img src="assets/img/icons/span1.png" alt="" /> Our Project</span>
                <h2 className="title tg-element-title">Driving Success Through Innovative IT Solution Project</h2>
              </div>
            </div>
          </div>

          <div className="space30"></div>
          <div className="row">
            <div className="project-slider owl-carousel" data-aos="fade-up" data-aos-duration="800">
              <div className="single-slider">
                <div className="slider-img">
                  <img src="assets/img/work/project-img1.png" alt="" />
                </div>
                <div className="heading">
                  <h3><a href="project-details.html">Enterprise Resource Planning Implementation</a></h3>
                  <a href="project-details.html" className="learn">Learn More <span><i className="fa-solid fa-arrow-right"></i></span></a>
                </div>
              </div>

              <div className="single-slider">
                <div className="slider-img">
                  <img src="assets/img/work/project-img2.png" alt="" />
                </div>
                <div className="heading">
                  <h3><a href="project-details.html">Enterprise Resource Planning Implementation</a></h3>
                  <a href="project-details.html" className="learn">Learn More <span><i className="fa-solid fa-arrow-right"></i></span></a>
                </div>
              </div>

              <div className="single-slider">
                <div className="slider-img">
                  <img src="assets/img/work/project-img3.png" alt="" />
                </div>
                <div className="heading">
                  <h3><a href="project-details.html">Enterprise Resource Planning Implementation</a></h3>
                  <a href="project-details.html" className="learn">Learn More <span><i className="fa-solid fa-arrow-right"></i></span></a>
                </div>
              </div>

              <div className="single-slider">
                <div className="slider-img">
                  <img src="assets/img/work/project-img1.png" alt="" />
                </div>
                <div className="heading">
                  <h3><a href="project-details.html">Enterprise Resource Planning Implementation</a></h3>
                  <a href="project-details.html" className="learn">Learn More <span><i className="fa-solid fa-arrow-right"></i></span></a>
                </div>
              </div>

              <div className="single-slider">
                <div className="slider-img">
                  <img src="assets/img/work/project-img2.png" alt="" />
                </div>
                <div className="heading">
                  <h3><a href="project-details.html">Enterprise Resource Planning Implementation</a></h3>
                  <a href="project-details.html" className="learn">Learn More <span><i className="fa-solid fa-arrow-right"></i></span></a>
                </div>
              </div>

              <div className="single-slider">
                <div className="slider-img">
                  <img src="assets/img/work/project-img3.png" alt="" />
                </div>
                <div className="heading">
                  <h3><a href="project-details.html">Enterprise Resource Planning Implementation</a></h3>
                  <a href="project-details.html" className="learn">Learn More <span><i className="fa-solid fa-arrow-right"></i></span></a>
                </div>
              </div>

            </div>


          </div>
        </div>
      </div> */}

      {/* <div className="pricing sp">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 m-auto text-center">
              <div className="heading1">
                <span className="span" data-aos="zoom-in-left" data-aos-duration="700"><img src="assets/img/icons/span1.png" alt="" /> Our Pricing Plan</span>
                <h2 className="title tg-element-title">Explore Our Flexible Pricing Plans</h2>
              </div>
            </div>
          </div>

          <div className="space30"></div>
          <div className="row">
            <div className="col-lg-4" data-aos="fade-up" data-aos-duration="700">
              <div className="single-pricing-box">
                <p className="title">Basic Plan</p>
                <h2>$9.9<span>/ month</span></h2>
                <p className="pera">Ideal for startups and small businesses looking get started essential IT services.</p>

                <div className="border"></div>

                <h4>Featured Included:</h4>
                <ul className="list">
                  <li><span><i className="fa-solid fa-check"></i></span> Network Monitoring</li>
                  <li><span><i className="fa-solid fa-check"></i></span> Helpdesk Support (Limited Hours)</li>
                  <li><span><i className="fa-solid fa-check"></i></span> Basic Cybersecurity Protection</li>
                </ul>

                <div className="space30"></div>
                <div className="button">
                  <a className="theme-btn1" href="#">Buy Now <span><i className="fa-solid fa-arrow-right"></i></span></a>
                </div>

              </div>
            </div>

            <div className="col-lg-4" data-aos="fade-up" data-aos-duration="1100">
              <div className="single-pricing-box active">
                <div className="most-popular">
                  <p>Most Popular</p>
                </div>

                <p className="title">Standard Plan</p>
                <h2>$19.9<span>/ month</span></h2>
                <p className="pera">Perfect for growing businesses that require additional features and support. </p>

                <div className="border"></div>

                <h4>Featured Included:</h4>
                <ul className="list">
                  <li><span><i className="fa-solid fa-check"></i></span> 24/7 Network Monitoring</li>
                  <li><span><i className="fa-solid fa-check"></i></span> Dedicated Helpdesk Support</li>
                  <li><span><i className="fa-solid fa-check"></i></span> Advance Cybersecurity Protection</li>
                  <li><span><i className="fa-solid fa-check"></i></span> Cloud Backup & Recovery</li>
                </ul>

                <div className="space30"></div>
                <div className="button">
                  <a className="theme-btn1" href="#">Buy Now <span><i className="fa-solid fa-arrow-right"></i></span></a>
                </div>

              </div>
            </div>


            <div className="col-lg-4" data-aos="fade-up" data-aos-duration="900">
              <div className="single-pricing-box">

                <p className="title">Premium Plan</p>
                <h2>$9.9<span>/ month</span></h2>
                <p className="pera">Tailored for larger enterprises with complex IT needs and stringent security.</p>

                <div className="border"></div>

                <h4>Featured Included:</h4>
                <ul className="list">
                  <li><span><i className="fa-solid fa-check"></i></span> Customised Network Monitoring</li>
                  <li><span><i className="fa-solid fa-check"></i></span> Priority Helpdesk Support</li>
                  <li><span><i className="fa-solid fa-check"></i></span> Comprehensive Cybersecurity Suite</li>
                  <li><span><i className="fa-solid fa-check"></i></span> Disaster Recovery Planning & Testing</li>
                  <li><span><i className="fa-solid fa-check"></i></span> Onsite Support (as needed)</li>
                </ul>

                <div className="space30"></div>
                <div className="button">
                  <a className="theme-btn1" href="#">Buy Now <span><i className="fa-solid fa-arrow-right"></i></span></a>
                </div>

              </div>
            </div>


          </div>
        </div>
      </div> */}

      {/* <OurTestimonials /> */}

      <div className="blog sp">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 m-auto text-center">
              <div className="heading1">
                <span className="span" data-aos="zoom-in-left" data-aos-duration="700"><img src="assets/img/icons/span1.png" alt="" /> Blog & Latest News</span>
                <h2 className="title tg-element-title">Latest News & Blog</h2>
              </div>
            </div>
          </div>
          <div className="space30"></div>
          <div className="row">
            <div className="col-lg-4">
              <div className="blog-box" data-aos="zoom-in-up" data-aos-duration="1100">
                <div className="image image-anime">
                  <img src="assets/img/blog/blog-img1.png" alt="" />
                </div>
                <div className="heading">
                  <div className="tags">
                    <a href="#"><img src="assets/img/icons/blog-icon1.png" alt="" /> John William</a>
                    <a href="#"><img src="assets/img/icons/blog-icon2.png" alt="" /> Feb 25, 24</a>
                  </div>
                  <h4><a href="#">Unlocking the Power of ServiceNow: A Strategic Guide for Enterprises</a></h4>
                  <a href="#" className="learn"> Learn More <span><i className="fa-solid fa-arrow-right"></i></span></a>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="blog-box" data-aos="zoom-in-up" data-aos-duration="900">
                <div className="image image-anime">
                  <img src="assets/img/blog/blog-img2.png" alt="" />
                </div>
                <div className="heading">
                  <div className="tags">
                    <a href="#"><img src="assets/img/icons/blog-icon1.png" alt="" /> John William</a>
                    <a href="#"><img src="assets/img/icons/blog-icon2.png" alt="" /> Feb 25, 24</a>
                  </div>
                  <h4><a href="#">Beyond IT: How ServiceNow Transforms Employee and Customer Experiences </a></h4>
                  <a href="#" className="learn"> Learn More <span><i className="fa-solid fa-arrow-right"></i></span></a>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="blog-box" data-aos="zoom-in-up" data-aos-duration="700">
                <div className="image image-anime">
                  <img src="assets/img/blog/blog-img3.png" alt="" />
                </div>
                <div className="heading">
                  <div className="tags">
                    <a href="#"><img src="assets/img/icons/blog-icon1.png" alt="" /> John William</a>
                    <a href="#"><img src="assets/img/icons/blog-icon2.png" alt="" /> Feb 25, 24</a>
                  </div>
                  <h4><a href="#">Future-Proofing Your Business with AI & Hyperautomation in ServiceNow</a></h4>
                  <a href="#" className="learn"> Learn More <span><i className="fa-solid fa-arrow-right"></i></span></a>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>


      <RequestComponent/>
    </div>
  );
}

export default Home;
